export const CARRIER_RENFE = '4R';
